import React, { ReactNode } from 'react';
import { classes } from 'typestyle';
import styles from './styles.module.scss';

interface Props {
  children?: ReactNode
  title: string
  style?: React.HTMLAttributes<HTMLDivElement>['style']
  onSelect?: () => any
  classes?: string[]
}

function TitleBar({ children, title, style, onSelect, classes: cls = [] }: Props) {
  return (
    <div className={classes(styles.titleBar, ...cls)}>
      <div
        className="element-background"
        style={style}
      />
      <div className="element" onClick={onSelect}>
        <div className="title">
          {title}
        </div>
        {children}
      </div>
    </div>
  );
}

export default TitleBar;
